import { RootState } from '@store/store';

export const getUserBotsSelector = (state: RootState) => state.userBots.userBots;
export const selectedUserBotSelector = (state: RootState) => state.userBots.selectedUserBot;
export const selectedCurrentUserBotSelector = (state: RootState) => state.userBots.currentUserBot;
export const selectCurrentBotLoadingStatus = (state: RootState) =>
  state.userBots.requests.getCurrentUserBotPending;
